<p-dialog [style]="{width: '50vw'}" [(visible)]="display" appendTo="body" (onShow)="showDialog($event)" (onHide)="hideDialog($event)" [modal]="true" [resizable]="false" [draggable]="false">
  <p-header>
      <p><label>{{ 'RedeliveryDialog.Header' | translate }}</label></p>
  </p-header>
  <div class="field grid">
    <label class="col-3">{{ 'RedeliveryDialog.AssignBookingForwarder' | translate }}</label>
    <div class="col-8">
      <p-dropdown
              [filter]="true"
              optionLabel="optionDesc"
              optionValue="optionCode"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
              appendTo="body"
              [options]="bookingForwarderList"
              [showClear]="true"
              [itemSize]="30"
              [virtualScroll]="true"
              [disabled]="true"
              [(ngModel)]="this.copyBillingBookingRequest.originBookingForwarder"
            ></p-dropdown>
    </div>

    <label class="col-3 mt-3">{{ 'RedeliveryDialog.RedeliveryCount' | translate }}</label>
    <div class="col-8 mt-3">
      <p-inputNumber
        mode="decimal"
        inputId="minmax"
        [min]="1"
        [(ngModel)]="redeliveryCount"
      ></p-inputNumber>
    </div>

  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick()" class="p-d-block mx-auto"></button>
  </ng-template>
</p-dialog>
